<mat-card class="mat-card--widget">
  <!-- CARD CONTENT -->
  <mat-card-content>
    <!-- <ecp-carousel class="mt-40" *ngIf="contentItem?.length">
      <ng-container *ngFor="let item of contentItem">
        <ecp-content-carousel-item *ecp-carouselItem [content]="item"></ecp-content-carousel-item>
      </ng-container>
    </ecp-carousel> -->
    <h3>Log in update!</h3>
    <p>
      Please be aware that we have updated our log in process. The first time you log in using your current credentials,
      you will receive an email at your login email address with a verification code. After verifying your email, you
      will be prompted to create a new password. It must be at least 12 characters and include 3 out of 4 of the
      following:
    </p>
    <ul style="margin-top: 20px;">
      <li>Upper case letter</li>
      <li>Lower case letter</li>
      <li>Number</li>
      <li>Symbol</li>
    </ul>
  </mat-card-content>
</mat-card>
